import React from "react";
import "./pickup_highcage.css";

/**
 * 🟦 PickupHighcageCard.jsx
 * แสดงบัตรแพ็กเกจ “คอกสูง 2+ / 3+”
 * สำหรับรถปิกอัพ ≤ 4 ตัน ที่มีคอกเหล็ก/ไม้/ตู้บรรทุก
 */

export default function PickupHighcageCard({ onSelect }) {
  return (
    <div className="pkg-card pickup-highcage">
      <div className="pkg-body">
        <h3>คอกสูง 2+ / 3+</h3>
        <p>สำหรับรถปิกอัพ ≤ 4 ตัน มีคอกเหล็ก/ไม้/ตู้บรรทุก</p>

        <ul className="pkg-list">
          <li>ทุนประกันภัย 100,000 – 500,000 บาท</li>
          <li>รับเฉพาะรถพาณิชย์ เสริมแหนบ</li>
          <li>เบี้ยเริ่มต้น 7,900 บาท (ประเภท 3+)</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect}>
          ดูรายละเอียด
        </button>
      </div>
    </div>
  );
}
